import React, { useEffect, useState } from "react";
import RevealOnScroll from "./RevealOnScroll";

const Products = ({ onQuoteRequest }) => {
  const [products, setProducts] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    const SHEET_ID = "1oxXPw_SRLsC-Z27-C0gUrdF0chwbwlriYQtLBTd94aE";
    const SHEET_NAME = "Sheet1";

    fetch(`https://opensheet.elk.sh/${SHEET_ID}/${SHEET_NAME}`)
      .then((res) => {
        if (!res.ok) throw new Error("Network error");
        return res.json();
      })
      .then((data) => {
        setProducts(data);
      })
      .catch((err) => {
        console.error(err);
        setError("Failed to fetch products.");
      });
  }, []);

  // 🔴 Error UI
  if (error) {
    return (
      <section className="products-section">
        <div className="container error-container">
          <div className="error-card">
            <h2>Products Temporarily Unavailable</h2>
            <p>Please refresh the page or try again later.</p>
            <button
              className="retry-btn"
              onClick={() => window.location.reload()}
            >
              Retry
            </button>
          </div>
        </div>
      </section>
    );
  }

  // 🟡 Loading State
  if (products.length === 0) {
    return (
      <section className="products-section">
        <div className="container loading-container">
          <div className="spinner"></div>
        </div>
      </section>
    );
  }

  const formatPrice = (price) => {
  if (!price) return null;
  const clean = String(price).replace(/[₹,\s]/g, "");
  if (isNaN(clean)) return price; // fallback if not number
  return `₹ ${Number(clean).toLocaleString("en-IN")}`;
};

  return (
    <section id="products" className="products-section">
      <div className="container">
        <RevealOnScroll>
          <h2>Our Stone Products</h2>
        </RevealOnScroll>

        <div className="products-grid">
          {products.map((product, index) => (
            <RevealOnScroll key={index}>
              <div className="product-card">
                <img
                  src={product.img}
                  alt={product.name}
                  loading="lazy"
                  onError={(e) => {
                    e.target.src = "/fallback.jpg";
                  }}
                  className="product-image"
                />

                <div className="product-card-content">
                  <h4>{product.name}</h4>

                  {product.price && (
  <p className="product-price">
    {formatPrice(product.price)}
  </p>
)}

                  <p>{product.description}</p>

                  <button
                    onClick={() => onQuoteRequest(product)}
                    className="quote-button"
                  >
                    Get a Quote
                  </button>
                </div>
              </div>
            </RevealOnScroll>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Products;